var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('div', {
    attrs: {
      "id": "confirmed"
    }
  }, [_c('h1', {
    staticClass: "mb-12 sm-md:mb-8"
  }, [_vm._v("\n\t\t\t\t\tCongratulations, your new Extra Debit Card is on its way!\n\t\t\t\t")]), _vm._v(" "), _c('img', {
    staticClass: "ml-auto mr-auto mb-12",
    attrs: {
      "src": require("assets/images/card_front-v3.png")
    }
  }), _vm._v(" "), !_vm.fromApp ? _c('h2', [_vm._v("Download the Extra app to activate your debit card and much more.")]) : _c('div', {
    staticClass: "flex"
  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "mx-auto text-center ml-auto mr-auto",
    attrs: {
      "href": "/app/dismiss"
    }
  }, [_c('button', {
    staticClass: "my-4 text-xl mx-auto"
  }, [_vm._v("Start using the app")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "mb-8 text-xl leading-8 p-4 sm-md:text-lg"
  }, [_c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("💸")]), _vm._v("\n\t\t\t\t\t\tStart using your virtual card today\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🛍")]), _vm._v("\n\t\t\t\t\t\tRedeem rewards points for experiences and more in our Rewards Store\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🤑")]), _vm._v("\n\t\t\t\t\t\tMonitor your Extra Debit Card transactions and activity\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("🎁")]), _vm._v("\n\t\t\t\t\t\tEnter into giveaways for free and win Extra big\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "flex mb-3"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_vm._v("📃")]), _vm._v("\n\t\t\t\t\t\tAccess all of your documents in the mobile app\n\t\t\t\t\t")])]);
}];
export { render, staticRenderFns };